const TERMINAL_STATUSES = new Set(['completed', 'failed'])

/**
 * Poll upload log details until status is completed or failed.
 * @param {(logId: string) => Promise<unknown>} fetchDetails
 * @param {string} logId
 * @param {{ intervalMs?: number, maxWaitMs?: number }} options
 */
export async function pollUploadLogUntilSettled(
  fetchDetails,
  logId,
  { intervalMs = 2000, maxWaitMs = 10 * 60 * 1000 } = {},
) {
  const started = Date.now()
  for (;;) {
    const response = await fetchDetails(logId)
    const log = response?.data ?? response
    if (log && TERMINAL_STATUSES.has(String(log.status || '').toLowerCase())) {
      return log
    }
    if (Date.now() - started >= maxWaitMs) {
      throw new Error(
        'Import is still running. Open Upload History to view results when it finishes.',
      )
    }
    await new Promise((resolve) => setTimeout(resolve, intervalMs))
  }
}
